<div
  *ngIf="banner as b"
  class="sub-banner"
  [class.sub-banner--warning]="b.severity === 'warning'"
  [class.sub-banner--critical]="b.severity === 'critical'"
  role="status"
  [attr.aria-live]="b.severity === 'critical' ? 'assertive' : 'polite'"
>
  <span class="sub-banner__icon" aria-hidden="true">
    <svg *ngIf="b.severity === 'warning'" viewBox="0 0 20 20" width="16" height="16" fill="none">
      <path d="M10 2.5 18 17H2L10 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
      <path d="M10 8v3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <circle cx="10" cy="14" r="0.9" fill="currentColor" />
    </svg>
    <svg *ngIf="b.severity === 'critical'" viewBox="0 0 20 20" width="16" height="16" fill="none">
      <circle cx="10" cy="10" r="7.5" stroke="currentColor" stroke-width="1.5" />
      <path d="M10 6v4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <circle cx="10" cy="13.5" r="0.9" fill="currentColor" />
    </svg>
  </span>

  <span class="sub-banner__badge">{{ b.badge }}</span>
  <span class="sub-banner__message">{{ b.message }}</span>

  <button
    *ngIf="canManageBilling"
    type="button"
    class="sub-banner__cta"
    (click)="goToYourProducts()"
  >{{ b.ctaLabel }}</button>
  <span *ngIf="!canManageBilling" class="sub-banner__cta-hint">Contact your account administrator.</span>
</div>
